export default "/images/1062cb1b105ee7a9b016cb5f737be26c.avif";